import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoaderEnabled } from '../../services/loader.service';
import { TariffDTO } from './tariffs.types';

@Injectable({
  providedIn: 'root',
})

export class TariffsApiService {
  constructor(private httpClient: HttpClient) {}

  @LoaderEnabled()
  fetchPublicTariffs(): Observable<TariffDTO[]> {
    return this.httpClient.get<TariffDTO[]>('/api/tariffs');
  }

  fetchKkmsTariffs(kkmId: number): Observable<TariffDTO[]> {
    return this.httpClient.get<TariffDTO[]>(`/api/kkms/${kkmId}/tariffs`);
  }

  fetchPublicTariffsByParams(params: HttpParams): Observable<TariffDTO[]> {
    return this.httpClient.get<TariffDTO[]>('/api/tariffsByModelAndSerial', {
      params,
    });
  }
}
